import { useNavigate } from 'react-router-dom';
import { backendApiUrl } from '../api/config';
import PersonalDetailsPage from '../components/Onboarding/PersonalDetailsPage';
import { ONBOARDING_STORAGE_KEY, ONBOARDING_STATUS_EVENT, ONBOARDING_LP_ID } from '../constant/constant';

function epochToDateConverter(timestamp) {
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const month = getMonthName(date.getMonth());
  const day = date.getDate();
  const daySuffix = getDaySuffix(day);

  return [day, daySuffix, month, year];
}

const getUserImage = async (prospectId, token, userid) => {
  const apiPhotoUrl = `${backendApiUrl}?moodlewsrestformat=json&wstoken=${token}&wsfunction=block_profile_get_user_profiledata&userid=${userid}&prospectid=${prospectId}`;
  const responseProfile = await fetch(apiPhotoUrl);
  const apiDataProfile = await responseProfile.json();
  let dataProfileData = apiDataProfile[0];
  return dataProfileData.userimage;
};
const preventContextMenu = (event) => {
  event.preventDefault();
};
function epochCurrentDateandTime() {
  var captureDateandTime = Math.floor(Date.now() / 1000);
  return captureDateandTime;
}

function epochCurrentTime() {
  const currentTimeInEpoch = Math.floor(new Date().getTime() / 1000);
  return currentTimeInEpoch;
}

function epochToTimeConverter(timestamp) {
  const date = new Date(timestamp * 1000);
  const timeString = date.toLocaleTimeString([], {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });

  return timeString;
}

function getCorrectedEpochTime(currentEpochDiff, tolerance = 5) {
  if (typeof currentEpochDiff !== 'number' || isNaN(currentEpochDiff)) {
    return Date.now();
  }
  const clientEpochInMs = Date.now();
  const toleranceInMs = tolerance * 1000;
  const currentEpochDiffInMs = currentEpochDiff * 1000;

  if (Math.abs(currentEpochDiffInMs) <= toleranceInMs) {
    return clientEpochInMs;
  } else {
    return clientEpochInMs - currentEpochDiffInMs;
  }
}

function getMonthName(monthIndex) {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  return monthNames[monthIndex];
}

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return 'th';
  }

  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

const parseQueryParams = () => {
  const urlParams = new URLSearchParams(document.location.search);
  const queryParams = {};
  for (const [key, value] of urlParams.entries()) {
    queryParams[key] = value;
  }
  return queryParams;
};

const setQueryParams = (paramObject) => {
  const searchParameter = new URLSearchParams();
  for (let key in paramObject) {
    searchParameter.set(key, paramObject[key]);
  }

  const currentPath = window.location.pathname;
  history.pushState(null, '', currentPath + '?' + searchParameter.toString());
};
const useRouteUpdate = (params, location, navigate, reset = false) => {
  let searchParams = {};
  searchParams = new URLSearchParams(reset ? [] : location.search);
  for (let key in params) {
    const value = params[key];

    if (value !== undefined && value !== null && value !== '') {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }
  }
  const newLocation = { ...location, search: searchParams.toString() };
  navigate(newLocation);
};

const removeQueryParams = (queryString) => {
  const urlParams = new URLSearchParams(document.location.search);
  urlParams.delete('logout');
};
function getBreakPoint(width) {
  const breakpoints = [
    1920, 1536, 1350, 1200, 1024, 991, 768, 601, 550, 425, 375, 350, 300
  ];

  let breakpointIndex = -1;
  for (let i = 0; i < breakpoints.length; i++) {
    if (width >= breakpoints[i]) {
      breakpointIndex = i;
      break;
    }
  }

  if (breakpointIndex === -1) {
    return '0';
  } else {
    return breakpointIndex.toString();
  }
}
const getwindowSizes = {
  larger_desktop: 1920,
  l_desktop: 1536,
  sm_desktop: 1350,
  m_desktop: 1200,
  s_desktop: 1024,
  s_tempdesktop: 649,
  l_tablet: 991,
  m_tablet: 768,
  s_tablet: 550,
  l_mobile: 425,
  m_mobile: 375,
  s_mobile: 350,
  xs_mobile: 300
};
// Get answer satus
const getAnswerStatus = (val) => {
  const userResponse = JSON.parse(val?.userresponse || '{}');
  const questionData = JSON.parse(val?.questiondata || '{}');
  // console.log(userResponse?.answer, 'dddddddd');

  if (val?.type === 'coderunner') {
    return val?.answered && userResponse?.answer?.trim()?.length > 0;
  }
  if (!val?.answered) {
    return false;
  }
  if (
    val?.type === 'truefalse' ||
    (Number(questionData?.single) && val?.type == 'multichoice')
  ) {
    if (
      userResponse?.answer?.length == 0 &&
      userResponse?.answer?.length !== undefined
    ) {
      return false;
    }

    if (!userResponse?.answer) {
      return false;
    }

    return userResponse?.answer !== '-1';
  } else if (val?.type === 'shortanswer' || val?.type === 'essay') {
    if (val?.type === 'essay') {
      // need to check for 2 file cases
      if (val?.responsefileareas?.length) {
        return true;
      }
    }
    if (
      userResponse?.answer?.length == 0 &&
      userResponse?.answer?.length !== undefined
    ) {
      return false;
    }
    return userResponse?.answer?.length;
  } else if (val?.type == 'multichoice') {
    return Boolean(
      Object.values(userResponse)?.filter((val) => Number(val))?.length
    );
  } else {
    return false;
  }
};

export const markOnboardingComplete = () => {
  localStorage.setItem(ONBOARDING_STORAGE_KEY, 'true');
  // Dispatch custom event to notify components that onboarding status changed
  window.dispatchEvent(new Event(ONBOARDING_STATUS_EVENT));
};

export const getOnboardingCompleted = () => {
  return localStorage.getItem(ONBOARDING_STORAGE_KEY) === 'true';
};

export const getHasPendingGrading = (overallScore, submissionData) => {
  return (
    Number(overallScore) === 0 &&
    (Number(submissionData?.assignement?.submitted) > 0 ||
      Number(submissionData?.quiz?.submitted) > 0 ||
      Number(submissionData?.project?.submitted) > 0)
  );
};

export const getIsEnrolledInOnboardingLp =
(traditionalPrograms, selfPacedPrograms) => {
  const isEnrolled =
    (Array.isArray(traditionalPrograms) && traditionalPrograms.some((p) => ONBOARDING_LP_ID.includes(Number(p.lpid)))) ||
    (Array.isArray(selfPacedPrograms) && selfPacedPrograms.some((p) => ONBOARDING_LP_ID.includes(Number(p.lpId))));
  return isEnrolled;
};

/**
 * Returns the prospect id to send with resume uploads. The upload endpoint
 * builds the resume file URL from this value, so it must be unique per user —
 * when prospectId is missing or the placeholder 'Vlearn', fall back to userid.
 * @param {string} prospectId - The learner's prospect id from profile data
 * @param {string|number} userid - The learner's user id (always unique)
 * @returns {string|number} - A value that is unique per user
 */
export const getUploadProspectId = (prospectId, userid) =>
  !prospectId || prospectId === 'Vlearn' ? userid : prospectId;

/**
 * Checks if all required profile fields are filled across all onboarding steps
 * @param {Object} profileData - The profile data object from Redux state
 * @returns {boolean} - Returns true if all required fields are filled, false otherwise
 */
export const checkAllRequiredFieldsFilled = (profileData) => {
  if (!profileData) {
    return false;
  }

  // Step 1: Personal Details - Required fields
  const personalFields = {
    firstName: profileData?.firstName,
    lastName: profileData?.lastName,
    gender: profileData?.gender,
    dateOfBirth: profileData?.dateOfBirth,
    whatsappNumber: profileData?.whatsappNumber,
    city: profileData?.city,
    pin: profileData?.pin,
    currentAddress: profileData?.currentAddress,
    age: profileData?.age,
  };

  // Check if LinkedIn profile exists in social profiles
  const socialProfiles = profileData?.workExperience?.socialProfiles || [];
  const hasLinkedIn = socialProfiles.some(
    (p) => p?.platform?.toLowerCase() === 'linkedin' && p?.profileLink
  );

  const isPersonalComplete =
    personalFields.firstName &&
    personalFields.firstName.trim() !== '' &&
    personalFields.lastName &&
    personalFields.lastName.trim() !== '' &&
    personalFields.gender &&
    personalFields.gender.trim() !== '' &&
    personalFields.dateOfBirth &&
    personalFields.dateOfBirth.trim() !== '' &&
    (!personalFields.whatsappNumber || /^[0-9]{10}$/.test(personalFields.whatsappNumber)) &&
    personalFields.city &&
    personalFields.city.trim() !== '' &&
    personalFields.pin &&
    personalFields.pin.trim() !== '' &&
    /^[0-9]{6}$/.test(personalFields.pin) &&
    personalFields.currentAddress &&
    personalFields.currentAddress.trim() !== '' &&
    hasLinkedIn;

  if (!isPersonalComplete) {
    return false;
  }

  // Step 2: Educational Details - Required fields
  const educationalQualifications = profileData?.educationalQualifications || [];

  // Find all qualification types
  const tenthQual = educationalQualifications.find(
    (edu) => edu.type === 'TENTH' || edu.level === 'Xth'
  );
  const diplomaQual = educationalQualifications.find(
    (edu) => edu.type === 'DIPLOMA'
  );
  const ugQual = educationalQualifications.find(
    (edu) => edu.type === 'UG'
  );
  const pgQual = educationalQualifications.find(
    (edu) => edu.type === 'PG'
  );
  const phdQual = educationalQualifications.find(
    (edu) => edu.type === 'PHD'
  );

  // Determine education path from which qualifications exist:
  // Diploma path: DIPLOMA exists, no UG
  // Graduation/Postgraduate/PhD paths: UG exists
  const isDiplomaPath = !!diplomaQual && !ugQual;

  // Schooling (10th) - required; 12th is optional (diploma students may not have 12th)
  const isSchoolingComplete =
    tenthQual &&
    tenthQual.institutionName &&
    tenthQual.institutionName.trim() !== '' &&
    tenthQual.institutionName !== 'Select an Option' &&
    tenthQual.marks &&
    tenthQual.marks.trim() !== '';

  if (!isSchoolingComplete) {
    return false;
  }

  // Diploma - required only if user chose the Diploma path (DIPLOMA exists, no UG)
  if (isDiplomaPath) {
    const isDiplomaComplete =
      diplomaQual.level &&
      diplomaQual.level.trim() !== '' &&
      diplomaQual.institutionName &&
      diplomaQual.institutionName.trim() !== '' &&
      diplomaQual.institutionName !== 'Select an Option' &&
      diplomaQual.specialization &&
      diplomaQual.specialization.trim() !== '' &&
      diplomaQual.marks &&
      diplomaQual.marks.trim() !== '';

    if (!isDiplomaComplete) {
      return false;
    }
  }

  // Graduation (UG) - required only if UG qualification exists (Graduation/Postgraduate/PhD paths)
  if (ugQual) {
    const isGraduationComplete =
      ugQual.level &&
      ugQual.level.trim() !== '' &&
      ugQual.level !== 'Select an Option' &&
      ugQual.institutionName &&
      ugQual.institutionName.trim() !== '' &&
      ugQual.institutionName !== 'Select an Option' &&
      ugQual.collegeName &&
      ugQual.collegeName.trim() !== '' &&
      ugQual.specialization &&
      ugQual.specialization.trim() !== '' &&
      ugQual.yearOfPassing &&
      ugQual.yearOfPassing.trim() !== '' &&
      ugQual.yearOfPassing !== 'Select an Option';

    if (!isGraduationComplete) {
      return false;
    }
  } else if (!isDiplomaPath) {
    return false;
  }

  // Postgraduate (PG) - only required if PG qualification exists
  if (pgQual) {
    const isPostgraduateComplete =
      pgQual.level &&
      pgQual.level.trim() !== '' &&
      pgQual.level !== 'Select an Option' &&
      pgQual.institutionName &&
      pgQual.institutionName.trim() !== '' &&
      pgQual.institutionName !== 'Select an Option' &&
      pgQual.specialization &&
      pgQual.specialization.trim() !== '' &&
      pgQual.yearOfPassing &&
      pgQual.yearOfPassing.trim() !== '';

    if (!isPostgraduateComplete) {
      return false;
    }
  }

  // PhD - only required if PhD qualification exists
  if (phdQual) {
    const isPhDComplete =
      phdQual.level &&
      phdQual.level.trim() !== '' &&
      phdQual.institutionName &&
      phdQual.institutionName.trim() !== '' &&
      phdQual.institutionName !== 'Select an Option' &&
      phdQual.specialization &&
      phdQual.specialization.trim() !== '' &&
      phdQual.marks &&
      phdQual.marks.trim() !== '';

    if (!isPhDComplete) {
      return false;
    }
  }

  // Step 3: Professional Details - Required fields
  const workExperience = profileData?.workExperience || {};

  // Determine if work experience exists based on actual data (same logic as ReviewScreen)
  const hasWorkExperienceData =
    (workExperience?.workExperienceYears && parseInt(workExperience.workExperienceYears) > 0) ||
    (workExperience?.workExperienceMonths && parseInt(workExperience.workExperienceMonths) > 0) ||
    (workExperience?.totalWorkExperience &&
      (parseInt(workExperience.totalWorkExperience.years || workExperience.totalWorkExperience) > 0 ||
        parseInt(workExperience.totalWorkExperience.months || 0) > 0)) ||
    workExperience?.currentDesignation ||
    workExperience?.currentOrganization;

  // If work experience data exists, all work experience fields are required
  if (hasWorkExperienceData) {
    const workExpYears = workExperience?.workExperienceYears ||
      (workExperience?.totalWorkExperience?.years) ||
      (typeof workExperience?.totalWorkExperience === 'number' ? workExperience.totalWorkExperience.toString() : '0');
    const workExpMonths = workExperience?.workExperienceMonths ||
      (workExperience?.totalWorkExperience?.months) || '0';

    const isWorkExperienceComplete =
      workExpYears !== undefined &&
      workExpYears !== null &&
      workExpYears !== '' &&
      workExpMonths !== undefined &&
      workExpMonths !== null &&
      workExpMonths !== '' &&
      workExperience?.salaryPerAnnum &&
      workExperience.salaryPerAnnum.trim() !== '' &&
      parseFloat(workExperience.salaryPerAnnum) > 0 &&
      workExperience?.currentOrganization &&
      workExperience.currentOrganization.trim() !== '' &&
      workExperience?.currentDesignation &&
      workExperience.currentDesignation.trim() !== '' &&
      workExperience?.industry &&
      workExperience.industry.trim() !== '' &&
      workExperience.industry !== 'Select an Option';

    if (!isWorkExperienceComplete) {
      return false;
    }
  }

  return true;
};

export {
  epochToDateConverter,
  epochToTimeConverter,
  getDaySuffix,
  getMonthName,
  epochCurrentDateandTime,
  preventContextMenu,
  parseQueryParams,
  removeQueryParams,
  setQueryParams,
  epochCurrentTime,
  useRouteUpdate,
  getwindowSizes,
  getAnswerStatus,
  getUserImage,
  getCorrectedEpochTime,
  getBreakPoint
};
